<template>
	<div>
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="mainLoaderSatus"
		>
			<Spinner />
		</div>
		<div :class="{ 'form-disabled': isUploadLocked }">
			<div class="secsub-left-quescontainer">
				<div class="sec-addquescontainer">
					<div class="d-flex">
						<div style="width: 40%" class="sec-addques-headtxt">MCQ</div>
						<div
							style="width: 20%"
							class="topDiv relativeclass ckeditor ques-tag-form-control w-40"
						>
							<b-form-tags
								v-model="questions.questionTags"
								ref="questionTagref"
								no-outer-focus
								remove-on-delete
								separator=" "
							>
								<template
									v-slot="{
										tags,
										inputAttrs,
										inputHandlers,
										tagVariant,
										removeTag,
									}"
								>
									<b-input-group class="cust-group-input" id="addcontainer-tag">
										<div class="d-flex no-wrap">
											<div
												class="d-inline-block cust-btn-select"
												style="font-size: 1.5rem"
											>
												<b-form-tag
													v-for="tag in tags"
													@remove="removeTag(tag)"
													:key="tag"
													:title="tag"
													:variant="tagVariant"
													class="mr-1 ml-2"
													>{{ tag }}</b-form-tag
												>
											</div>
											<b-form-input
												id="input-tag"
												v-bind="inputAttrs"
												v-on="inputHandlers"
												@keyup="hashtag()"
												placeholder="Enter Question tag"
												class="form-control min-width mr-4 ml-2"
											></b-form-input>
										</div>
									</b-input-group>
								</template>
							</b-form-tags>
						</div>

						<div class="relativeclass ml-2" ref="showdiffoptions">
							<div
								v-if="showdiffoptions"
								class="diff-dropdown d-flex"
								ref="showdiffoptions1"
								v-closable="{
									exclude: ['showdiffoptions1', 'showdiffoptions'],
									handler: 'hidediffoptions',
								}"
							>
								<b-form-group class="sec-mcq-datacard">
									<b-form-radio-group
										class="text-align-center new-difficulty-level-class"
										id="btn-radios-3"
										:options="options"
										value-field="value"
										text-field="text"
										name="radio-btn-stacked"
										@change="showdiffoptions = !showdiffoptions"
										buttons
										stacked
										v-model.trim="$v.questions.difficultyLevel.$model"
									></b-form-radio-group>
								</b-form-group>
							</div>
							<div
								class="sec-addquesbox-rightside"
								@click="showdiffoptions = !showdiffoptions"
							>
								<b-form-input
									style="background: transparent"
									class="pointer"
									readonly
									:class="{
										error: $v.questions.difficultyLevel.$error,
									}"
								>
								</b-form-input>
								<div class="placeholder">
									Difficulty Level {{ questions.difficultyLevel
									}}<span v-if="questions.difficultyLevel == ''">*</span>
								</div>
								<div
									style="position: absolute; top: 5px; right: 25px"
									v-if="
										$v.questions.difficultyLevel.$dirty &&
											!$v.questions.difficultyLevel.required
									"
									v-b-popover.hover.top.v-danger="{ content: 'Required' }"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div class="diff-downarrow">
									<img
										v-if="!showdiffoptions"
										src="../../assets/downarrow.svg"
										alt=""
										class="mr-2 pointer"
									/>
									<img
										v-else
										class="mr-2 pointer"
										src="../../assets/uparrow.svg"
										alt=""
									/>
								</div>
							</div>
						</div>
						<div style="width: 20%" class="relativeclass ml-2">
							<b-form-input
								v-model.trim="$v.questions.marks.$model"
								:class="{
									error: $v.questions.marks.$error,
								}"
								@keypress="validateMarks($event)"
							>
							</b-form-input>
							<div
								class="placeholder"
								v-if="questions.marks == null || !$v.questions.marks.required"
							>
								Marks <span>*</span>
							</div>
							<div
								style="position: absolute; top: 5px; right: 7px"
								v-if="$v.questions.marks.$dirty && !$v.questions.marks.required"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								style="position: absolute; top: 5px; right: 7px"
								v-if="
									!$v.questions.marks.between && $v.questions.marks.required
								"
								v-b-popover.hover.top.v-danger="{
									content: 'Should be between (0.5, 100)',
								}"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								style="position: absolute; top: 5px; right: 7px"
								v-if="!$v.questions.marks.alpha && $v.questions.marks.required"
								v-b-popover.hover.top.v-danger="{
									content: 'Accepts only 2 digit after decimal point',
								}"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>
					</div>

					<div class="mt-2">
						<div class="topDiv mt-3 relativeclass">
							<div
								:class="
									dirtyMcqQuestion ||
									(!$v.questions.question.maxLength && !dirtyMcqQuestion)
										? 'error'
										: ''
								"
							>
								<label class="addquesboxfieldsetStyle" style="z-index: 4">
									Question &nbsp;<span class="asterik">*</span></label
								>

								<QuillEditor
									:addquesProp="addques"
									:value="$v.questions.question.$model"
									@validationVal="validateText"
									@questionText="updateQuestionContent"
									@addquesBack="changedaddQues"
								>
								</QuillEditor>
								<div
									style="position: absolute; top: 10px; right: 20px"
									v-if="dirtyMcqQuestion && $v.questions.question.required"
									v-b-popover.hover.top.v-danger="{
										content: 'Required',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div
									style="position: absolute; top: 10px; right: 20px"
									v-if="!$v.questions.question.maxLength && !dirtyMcqQuestion"
									v-b-popover.hover.top.v-danger="{
										content: 'Should not exceed 10000 characters',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
							</div>

							<div class="media-box mt-2 align-items-center">
								<div class="d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center">
										<div class="media-text ml-3">Add Media</div>
										<div class="ml-2">
											<img src="../../assets/vertical-line.svg" alt="" />
										</div>
										<div class="d-flex align-items-center ml-2 mt-1">
											<div
												class="ml-2"
												v-b-tooltip.hover="{ variant: 'secondary' }"
												title="Audio supported formats are: wav, mp3"
											>
												<label for="file-upload" class="pointer">
													<img src="../../assets/headphone.svg" alt="" />
												</label>
												<input
													id="file-upload"
													type="file"
													accept="audio/*"
													@change="previewFile"
												/>
											</div>
											<div
												class="ml-3"
												v-b-tooltip.hover="{ variant: 'secondary' }"
												title=" Video supported formats is: mp4"
											>
												<label for="file-upload-video" class="pointer">
													<img src="../../assets/videocam.svg" alt="" />
												</label>
												<input
													id="file-upload-video"
													type="file"
													accept="video/*"
													@change="previewFile"
												/>
											</div>
											<div
												class="ml-3"
												v-b-tooltip.hover="{ variant: 'secondary' }"
												title="Image supported formats are: jpg, jpeg, png"
											>
												<label for="file-upload-image" class="pointer">
													<img src="../../assets/image-capture.svg" alt="" />
												</label>
												<input
													id="file-upload-image"
													type="file"
													accept="image/*"
													@change="previewFile"
												/>
											</div>
										</div>
									</div>

									<div
										class="d-flex align-items-center"
										v-if="questions.isFailed"
									>
										<img src="../../assets/Vector.svg" alt="" class="mr-2" />
										<p class="uploadfailed mb-0 mr-2">Invalid media file</p>
									</div>
								</div>
							</div>

							<div
								style="position: absolute; top: 10px; right: 20px"
								v-if="dirtyMcqQuestion && !$v.questions.question.required"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>
						<!-- below div comes if image exists -->
						<template v-if="checkMedia">
							<div
								v-if="isImage(questions.questionMediaType)"
								class="mt-2 d-flex align-items-center justify-content-center"
							>
								<div class="relativeclass">
									<div class="dbmcqcardimage">
										<img
											:src="questions.questionMedia"
											alt=""
											class="w-100 h-100"
										/>
									</div>
									<div @click="removeMedia()" class="xMarkImageCancel">
										<img
											src="../../assets/icons/Qpbuilder/imagecloseicon.svg"
											alt=""
										/>
									</div>
								</div>
							</div>

							<!-- below div comes if audio exists -->
							<div
								v-if="isAudio(questions.questionMediaType)"
								class="d-flex justify-content-center mt-3"
							>
								<div class="d-flex align-items-center relativeclass">
									<Media
										:kind="'audio'"
										:isMuted="false"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="mcqdatacard-audio"
										:src="questions.questionMedia"
									></Media>
									<div class="mcq-audioxmark pointer" @click="removeMedia()">
										<img src="../../assets/xmark.svg" alt="" />
									</div>
								</div>
							</div>
							<div
								v-if="isVideo(questions.questionMediaType)"
								class="mt-3 d-flex align-items-center justify-content-center"
							>
								<div class="relativeclass">
									<Media
										:kind="'video'"
										:isMuted="false"
										:src="questions.questionMedia"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="dbmcqcardimage"
									></Media>
									<div @click="removeMedia()" class="xMarkImageCancel">
										<img
											src="../../assets/icons/Qpbuilder/imagecloseicon.svg"
											alt=""
										/>
									</div>
								</div>
							</div>
						</template>
						<b-row v-if="showVideoUploading">
							<b-col class="ab-uploaded-card w-100 mt-3">
								<b-card no-body class="d-flex w-100">
									<section class="d-flex align-items-center pt-1">
										<div
											class="ab-uploaded-file-heading d-flex align-items-center w-75"
										>
											{{ videoData.name }}
										</div>

										<div
											class="ab-uploaded-file-subheading w-20 d-flex justify-content-end align-items-center gap-2"
										>
											<b-spinner
												v-if="showSpinner"
												label="Spinning"
											></b-spinner>
											<span>{{ formatSize(videoData.size) }}</span>
											<!-- <span class="ml-2"> 2 sec Left</span> -->
										</div>
										<!-- 
									<img
										:class="progress <= 0 ? 'opacity-50' : 'pointer'"
										@click="progress > 0 ? removeFile('video') : ''"
										class="ml-3"
										src="@/assets/common/blue-cross.svg"
										alt=""
									/> -->
									</section>
									<section class="mt-2">
										<b-progress height="4px" :value="progress"></b-progress>
									</section>
								</b-card>
							</b-col>
						</b-row>
						<div class="select-option mt-3" v-if="singletick == true">
							Select an Option<span class="asterik">*</span>
						</div>

						<div
							class="mt-2 ml-3 mb-4 sec-quesbox-radios mcq-form-option relativeclass"
						>
							<b-row class="p-2 align-items-end">
								<b-col
									cols="6"
									v-for="(i, index) in questions.options"
									:key="index"
									:class="{
										'mt-3': index > 0,
									}"
								>
									<div class="relativeclass d-flex align-items-center">
										<div
											class="mcq-checkbox"
											:class="{
												'mt-40px': optionPreviews[index],
											}"
										>
											<b-form-checkbox
												v-model.trim="i.check"
												@change="icheck"
												name="some-radios"
											></b-form-checkbox>
										</div>
										<div class="position-relative w-100">
											<b-form-input
												:placeholder="`Enter option ${index + 1}`"
												v-model.trim="i.value"
												:class="{
													'h-150px': optionPreviews[index],
													'has-option-error': getDuplicateIndexes().has(index),
												}"
												:disabled="i.media !== ''"
											>
											</b-form-input>
											<div
												:class="
													questions.options.length > 2 && i.check != true
														? 'option-validation-icon'
														: 'option-validation-icon1'
												"
												v-if="
													$v.questions.options.$each[index].value.$dirty &&
														!$v.questions.options.$each[index].value
															.valueOrMediaRequired
												"
												v-b-popover.hover.top.v-danger="{ content: 'Required' }"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
											<div
												:class="
													questions.options.length > 2 && i.check != true
														? 'option-validation-icon'
														: 'option-validation-icon1'
												"
												v-if="
													!$v.questions.options.$each[index].value.maxLength &&
														$v.questions.options.$each[index].value.required
												"
												v-b-popover.hover.top.v-danger="{
													content: 'Should not exceed 1024 characters',
												}"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>

											<div v-if="optionPreviews[index]">
												<div
													class="uploaded-option-image"
													@mouseover="showoptionImageicons = index"
													@mouseleave="showoptionImageicons = null"
												>
													<img
														:src="optionPreviews[index]"
														alt=""
														class="w-100 h-100 overflow-hidden"
														style="border-radius: 4px;"
													/>
													<div
														v-if="showoptionImageicons === index"
														class="image-blur-overlay"
													></div>
													<div
														class="align-items-center mcq-image-option-hovered-icons"
														v-if="showoptionImageicons === index"
													>
														<img
															src="../../assets/icons/Qpbuilder/imagepreview.svg"
															alt=""
															class="pointer"
															@click.stop.prevent="
																openPreview(optionPreviews[index])
															"
														/>
														<img
															src="../../assets/icons/Qpbuilder/imageclose.svg"
															alt=""
															class="pointer ml-2"
															@click.stop="removeOptionImage(i, index)"
														/>
													</div>
												</div>
											</div>
										</div>

										<div
											v-if="questions.options.length > 2 && i.check != true"
											class="mcq-radio-option-delete pointer"
										>
											<img
												src="../../assets/icons/Qpbuilder/mcqoptiondelete.svg"
												alt=""
												@click="deleteOptions(index)"
											/>
										</div>

										<div>
											<label
												:for="`file-upload-image-${index}`"
												class="pointer"
											>
												<img
													:class="{
														right27px:
															questions.options.length > 2 && i.check != true,
													}"
													class="mcq-radio-option-image"
													src="../../assets/icons/Qpbuilder/optionimage.svg"
													alt=""
													v-b-tooltip.hover="{ variant: 'secondary' }"
													title="Image supported formats are: jpg, jpeg, png"
												/>
											</label>
											<input
												:id="`file-upload-image-${index}`"
												type="file"
												accept="image/*"
												@change="previewOptionfile($event, index)"
												style="display: none"
											/>
										</div>
									</div>
								</b-col>
							</b-row>
							<div class="asterik mt-1" v-if="duplicateOptionError">
								Duplicate options are not allowed.
							</div>
							<div class="asterik" v-if="moreOption">
								Cannot add more than 8 options<span class="asterik">*</span>
							</div>
						</div>
					</div>
					<div class="error_msg mt-3" v-if="erroroption == true">
						<div class="error_text">
							To add a question, please select one of the options here.
						</div>
					</div>
				</div>

				<div
					class="sec-addquescheckboxcontainer m-3 d-flex justify-content-between"
				>
					<div class="d-flex align-items-center">
						<div
							class="d-flex align-items-center pointer mb-3"
							:class="{ 'disabled-opt': duplicateOptionError }"
							@click="!duplicateOptionError && addOptions()"
						>
							<img src="../../assets/secplusicon.svg" alt="" />
							<div class="sec-addquestext ml-2">Add more options</div>
						</div>

						<b-form-checkbox
							class="ml-3 sec-checboxtext mb-1"
							v-model="questions.autoCorrection"
						>
							Auto Evaluation
						</b-form-checkbox>
						<b-form-checkbox
							class="ml-3 sec-checboxtext mb-1"
							v-model="questions.required"
						>
							Mandatory question
						</b-form-checkbox>
					</div>
					<div class="d-flex pointer relativeclass">
						<div class="sec-addcheckboxtext mr-3" ref="showdatacard1">
							<span
								@click="
									type == 'automcq' ? addautomcqquestion() : addquestion()
								"
								>Add</span
							>
						</div>
						<div @click="clearData()" class="sec-canceltext-active">Cancel</div>
						<div
							v-if="showdatacard"
							ref="showdatacard"
							v-closable="{
								exclude: ['showdatacard', 'showdatacard1'],
								handler: 'hidedatacard',
							}"
						>
							<div class="sec-adddata-card d-flex align-items-center">
								<b-form-group class="sec-mcq-datacard">
									<b-form-checkbox
										class="qb-dropdown-option-sing"
										size="sm"
										v-model="questions.addToDatabank"
										name="flavour-4a"
									>
										Add to Questionbank
									</b-form-checkbox>
									<b-form-checkbox
										class="qb-dropdown-option-sing"
										size="sm"
										v-model="questions.addToPublic"
										name="flavour-4a"
									>
										Add to public
									</b-form-checkbox>
								</b-form-group>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Upload Modal start -->
		<b-modal
			id="attachdocs"
			v-model="uploadModal"
			centered
			hide-footer
			hide-header
			@show="resetModal"
			@hidden="resetModal"
		>
			<div @click="closeattachdocsmodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<div class="relativeclass sec-attachdocs">
				<div class="dot-main">
					<div
						class="d-flex align-items-center justify-content-center flex-column"
					>
						<div class="sec-attachdocs-text d-flex flex-column mt-2 pointer">
							<div>
								<label for="file-upload" class="custom-file-upload pointer">
									<div class="d-flex flex-column align-items-center">
										<img
											src="../../assets/icons/Qpbuilder/uploadicon.svg"
											alt=""
										/>
										Click to browse or drag <br />and drop your files
									</div>
								</label>
								<input id="file-upload" type="file" @change="previewFile" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<!-- Upload Modal end -->
		<b-modal
			id="viewimagemodal"
			centered
			hide-footer
			hide-header
			v-model="isImageModalOpen"
		>
			<div class="">
				<img
					:src="previewImage"
					alt="Preview"
					class="h-100 w-100 overflow-hidden border-image"
					v-if="previewImage"
				/>
			</div>
		</b-modal>
		<div
			v-if="isImageModalOpen"
			@click="isImageModalOpen = false"
			class="mcq-image-modalclose pointer"
		>
			<img
				class="rotate-on-hover"
				src="../../assets/icons/Qpbuilder/imageclose2.svg"
				alt=""
			/>
		</div>
	</div>
</template>

<script>
import QuillEditor from "./quillEditor.vue"; //Quill editor from component
import Media from "@dongido/vue-viaudio";
import { isImage, isVideo, isAudio } from "../../utils/checkFileType.js";
import {
	required,
	maxLength,
	helpers,
	between,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import { postMCQquestionv2 } from "../../utils/apiFunctions";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import mediaUploadMixin from "@/views/mixin/mediaUploadMixin";
import socketUploadMixin from "@/views/mixin/socketUploadMixin";
import toast from "../../views/mixin/toast";
const valueOrMediaRequired = helpers.withParams(
	{ type: "valueOrMediaRequired" },
	function(value, parentVm) {
		return !!value || !!parentVm.media;
	}
);
export default {
	name: "mcq",
	mixins: [toast, mediaUploadMixin, socketUploadMixin],
	components: {
		Media,
		QuillEditor, //From quill component
		Spinner,
	},
	props: {
		type: String,
		autosectionID: String,
		questions: Object,
	},
	data() {
		return {
			duplicateOptionError: false,
			showVideoUploading: false, // controls ab-uploaded-card visibility
			progress: 0, // progress bar value
			videoData: {}, // { name, size }
			showSpinner: false, // spinner near size
			mainLoaderSatus: false,
			previewImage: "",
			isImageModalOpen: false,
			dirtyMcqQuestion: false,
			showdiffoptions: false,
			uploadModal: false,
			isFailed: false,
			moreOption: false,
			showdatacard: false,
			checkMedia: false,
			singletick: true,
			erroroption: false,
			options: [
				{
					value: "1",
					text: "Difficulty Level 1",
				},
				{
					value: "2",
					text: "Difficulty Level 2",
				},
				{
					value: "3",
					text: "Difficulty Level 3",
				},
				{
					value: "4",
					text: "Difficulty Level 4",
				},
				{
					value: "5",
					text: "Difficulty Level 5",
				},
			],

			addques: false,
			optionPreviews: [],
			showoptionImageicons: null,
		};
	},
	watch: {
		"questions.options": {
			handler() {
				this.duplicateOptionError = this.hasDuplicateOptions();
			},
			deep: true,
		},
		selectedSection(newValue, oldValue) {
			if (newValue != oldValue) {
				this.questions.questionMediaType = "";
				this.questions.questionMedia = "";
			}
		},
	},

	computed: {
		isUploadLocked() {
			return this.showVideoUploading;
		},
		...mapGetters("autotestVUEX", {
			autoselectedSection: "getSelectedSection",
			topicID: "getAutoTopicID",
		}),
		...mapGetters("sectionVUEX", {
			selectedSection: "getSelectedSection",
			questionAdded: "getQuestionAdded",
		}),
	},
	validations: {
		questions: {
			marks: {
				required,
				alpha: helpers.regex("alpha", /^\d{1,3}\.?\d{0,2}$/),
				between: between(0.5, 100),
			},
			difficultyLevel: {
				required,
			},
			question: {
				required,
				maxLength: maxLength(10000),
			},
			options: {
				$each: {
					value: {
						valueOrMediaRequired,
						maxLength: maxLength(1024),
					},
				},
			},
		},
	},

	created() {
		if (this.questions.file && this.questions.questionMedia) {
			this.checkMedia = true;
		}
		for (let i of this.questions.options) {
			if (i.check) this.singletick = false;
		}
	},

	methods: {
		getDuplicateIndexes() {
			const map = {};
			const duplicates = new Set();

			this.questions.options.forEach((opt, idx) => {
				const key = (opt.value || "")
					.toLowerCase()
					.trim()
					.replace(/\s+/g, " ");

				if (!key) return;

				if (map[key] !== undefined) {
					duplicates.add(map[key]);
					duplicates.add(idx);
				} else {
					map[key] = idx;
				}
			});

			return duplicates; // Set of indexes
		},
		hasDuplicateOptions() {
			const seen = new Set();

			for (const opt of this.questions.options) {
				// normalize text
				const text = (opt.value || "")
					.toLowerCase()
					.trim()
					.replace(/\s+/g, " ");

				// normalize media
				const media = opt.media || "";

				const key = text || media;

				if (!key) continue;

				if (seen.has(key)) {
					return true;
				}
				seen.add(key);
			}

			return false;
		},

		formatSize(bytes) {
			if (!bytes && bytes !== 0) return "";

			const kb = bytes / 1024;

			if (kb < 1024) {
				return `${kb.toFixed(1)} KB`;
			}

			return `${(kb / 1024).toFixed(1)} MB`;
		},
		openPreview(imageUrl) {
			this.previewImage = imageUrl;
			this.isImageModalOpen = true;
		},
		removeOptionImage(i, index) {
			this.optionPreviews.splice(index, 1, null);
			i.media = "";
			i.mediaValue = "";
		},
		previewOptionfile(event, index) {
			const file = event.target.files[0];
			if (!file) return;

			const reader = new FileReader();
			const media = `optionMediaValue_${index}`;

			reader.onload = (e) => {
				let parts = file.name.split(".");
				let ext = parts[parts.length - 1];
				if (!isImage(ext)) {
					this.errorToast("Invalid media file");
					return;
				}
				// 1. Save key to media field for display reference
				this.questions.options[index].media = media;
				// 2. Store actual File in questions array using dynamic key
				this.questions[media] = file;

				// Optional: if you want preview in template
				// this.questions.options[index].mediaPreview = e.target.result;
				while (this.optionPreviews.length <= index) {
					this.optionPreviews.push(null);
				}

				// Replace at correct index
				this.optionPreviews.splice(index, 1, e.target.result);
				this.questions.options[index].value = "";
				this.$forceUpdate();
			};

			reader.readAsDataURL(file);

			// Clear input so same file can be re-uploaded
			event.target.value = "";
		},
		validateMarks(event) {
			const charCode = event.keyCode || event.which;
			const charTyped = String.fromCharCode(charCode);
			// Regular expression to allow only numbers and a single dot
			const regex = /^(?!0{2,})\d{1,3}(?:\.\d{0,2})?$/;
			// If the typed character is not a number or dot, prevent the default behavior
			if (!regex.test(event.target.value + charTyped)) {
				event.preventDefault();
			}
		},
		validateText(val) {
			this.dirtyMcqQuestion = val;
		},
		updateQuestionContent(newContent) {
			this.questions.question = newContent;
		},
		changedaddQues(newval) {
			this.addques = newval;
		},

		//For removing Space From Top and bottom of last text of Quill Editor
		getDesiredContent() {
			const tempDiv = document.createElement("div");
			tempDiv.innerHTML = this.questions.question;
			const pTags = tempDiv.querySelectorAll("p");

			let endIndex = pTags.length;
			for (let i = pTags.length - 1; i >= 0; i--) {
				if (this.isBetweenContentTag(pTags[i])) {
					endIndex = i + 1;
					break;
				}
			}
			pTags.forEach((pTag, index) => {
				if (index >= endIndex && !pTag.textContent.trim()) {
					tempDiv.removeChild(pTag);
				}
			});
			this.questions.question = tempDiv.innerHTML;
		},
		isBetweenContentTag(element) {
			return element.textContent.trim() !== "";
		},

		isImage,
		isVideo,
		isAudio,
		hidedatacard() {
			this.showdatacard = false;
		},

		hidediffoptions() {
			this.showdiffoptions = false;
			this.showdatacard = false;
		},
		async previewFile(event) {
			const file = event.target.files[0];
			if (!file) return;
			this.questions.file = file;
			// 1Set upload UI state
			this.videoData = {
				name: file.name,
				size: file.size,
			};

			await this.handleMediaUpload(event, this.questions);

			this.checkMedia = !this.questions.isFailed;
		},
		scrollToRight() {
			const scrollContainer = document.getElementById("addcontainer-tag");
			scrollContainer.scrollTo({
				top: 0,
				left: scrollContainer.scrollWidth,
				behavior: "smooth",
			});
		},
		addquestiontag() {
			const el1 = document.getElementById("add-tag");
			el1.adcreateFormDatadEventListener("click", this.scrollToRight, false);
		},
		hashtag() {
			let str = document.getElementById("input-tag").value;
			let tagged = str.replace(/#/g, "").replace(/([a-zA-Z0-9]+)/g, "#" + "$1");
			document.getElementById("input-tag").value = tagged;
		},

		async addquestion() {
			if (this.questions.file) {
				this.showVideoUploading = true;
			}
			if (this.duplicateOptionError) {
				this.errorToast("Duplicate options are not allowed.");
				return;
			}
			this.showSpinner = true;

			this.$v.$touch();

			if (!this.validateInputs()) {
				this.errorToast("Please enter all the details");
				return;
			}

			try {
				let bucketPath = null;

				//  ONLY ADD THIS
				if (this.questions.file && this.questions.fileMeta) {
					bucketPath = await this.uploadFileViaSocket(
						this.questions.file,
						this.questions.fileMeta
					);
				}

				// pass bucketPath to existing method
				const form = this.createFormData(bucketPath);

				const res = await postMCQquestionv2(form);

				if (res.status === 200) {
					this.successToast("Question added successfully!");
					this.showVideoUploading = false;
					this.showSpinner = false;
					this.progress = 0;
					this.videoData = {};
					this.$emit("question-added");
				}
			} catch (err) {
				this.errorToast(err?.message || "Something went wrong");
			}
		},
		validateInputs() {
			if (this.questions.question === "") {
				this.dirtyMcqQuestion = true;
			}
			if (this.duplicateOptionError) {
				return false;
			}
			let single = this.countSelectedOptionsQP();
			console.log(single, "single");
			if (single === 0) {
				this.singletick = true;
				this.erroroption = true;
			} else {
				this.single = false;
				this.erroroption = false;
			}
			console.log(
				!this.singletick && !this.$v.$invalid && !this.dirtyMcqQuestion
			);
			return !this.singletick && !this.$v.$invalid && !this.dirtyMcqQuestion;
		},

		countSelectedOptionsQP() {
			let single = 0;
			for (let i in this.questions.options) {
				if (this.questions.options[i].check) {
					single += 1;
				}
			}
			return single;
		},

		createFormData(bucketPath = null) {
			let form = new FormData();
			let questiontags = this.questions.questionTags.map((s) =>
				s[0] === "#" ? s.slice(1) : s
			);

			this.getDesiredContent();

			for (let key in this.questions) {
				if (key === "questionFile" || key === "file" || key === "fileMeta") {
					continue;
				}
				if (key === "questionMedia") {
					if (bucketPath) {
						form.append("questionMediaPath", bucketPath);
						form.append("questionMediaType", this.questions.questionMediaType);
					} else if (
						!this.questions.file &&
						this.questions.questionMedia !== ""
					) {
						continue;
					} else {
						form.append("delete", 1);
					}
					continue;
				} else if (key === "options") {
					const optionsCopy = JSON.stringify(this.questions.options);
					form.append("options", optionsCopy);
				} else if (key === "questionTags") {
					form.append(key, JSON.stringify(questiontags));
				} else if (key === "addToDatabank") {
					form.append("addToDatabank", true);
				} else {
					form.append(key, this.questions[key]);
				}
			}

			form.append("sectionID", this.selectedSection.sectionID);
			form.append("testID", this.selectedSection.testID);

			return form;
		},

		async addautomcqquestion() {
			console.log("AutoMCQ");
			this.prepareQuestionTags();

			if (this.questions.question === "") {
				this.dirtyMcqQuestion = true;
			}
			this.questions.topic = "--";

			this.$v.$touch();
			const selectedOptionsCount = this.countSelectedOptions();

			if (selectedOptionsCount === 0) {
				this.singletick = true;
				this.erroroption = true;
			} else {
				this.single = false;
				this.erroroption = false;
			}

			if (!this.singletick) {
				await this.handleFormSubmission();
			} else {
				this.errorToast("Please enter all the details");
			}
		},

		prepareQuestionTags() {
			this.questions.questionTags = this.questions.questionTags.map((s) =>
				s[0] === "#" ? s.slice(1) : s
			);
		},

		countSelectedOptions() {
			return this.questions.options.filter((option) => option.check).length;
		},

		async handleFormSubmission() {
			if (this.questions.file) {
				this.showVideoUploading = true;
			}
			this.showSpinner = true;
			if (!this.$v.$invalid && !this.dirtyMcqQuestion) {
				let bucketPath = null;

				if (this.questions.file && this.questions.fileMeta) {
					bucketPath = await this.uploadFileViaSocket(
						this.questions.file,
						this.questions.fileMeta
					);
				}
				const form = this.buildFormData(bucketPath);

				try {
					const response = await postMCQquestionv2(form);
					if (response.status === 200) {
						this.successToast("Question added successfully!");
						this.questions.questionKey = response.data.data.QuestionID;
						this.$emit("question-added");
						this.showVideoUploading = false;
						this.showSpinner = false;
						this.progress = 0;
						this.videoData = {};
					} else {
						this.errorToast("Something went wrong!");
					}
				} catch (error) {
					this.errorToast("Something went wrong!");
				}

				this.clearData();
			} else {
				this.errorToast("Please enter all the details");
			}
		},

		buildFormData(bucketPath) {
			const form = new FormData();
			this.getDesiredContent();

			for (const key in this.questions) {
				if (key === "questionMedia") {
					// no media
					if (!this.questions.file && !this.questions.questionMedia) {
						form.set("delete", 1);
						continue;
					}

					// unchanged media
					if (!this.questions.file && this.questions.questionMedia) {
						continue;
					}

					// new media via socket
					if (bucketPath) {
						form.append("questionMediaPath", bucketPath);
						form.append("questionMediaType", this.questions.questionMediaType);
					}
					continue;
				} else if (key === "options") {
					this.questions[key] = JSON.stringify(this.questions.options);
					form.append(key, this.questions[key]);
					this.questions[key] = JSON.parse(this.questions[key]);
				} else if (key === "questionTags") {
					form.append(key, JSON.stringify(this.questions.questionTags));
				} else {
					form.append(key, this.questions[key]);
				}
			}

			form.append("sectionID", this.autosectionID);
			form.append("testID", this.$route.params.testID);
			form.append("topicID", this.topicID);
			form.append("type", "ADD_QUES");
			form.append("selected", "A");
			form.append("delete", "1");

			return form;
		},

		icheck() {
			this.singletick = false;
			this.erroroption = false;
			// for (let j in this.questions.options) {
			//   if (this.questions.options[j].check) {
			//     this.questions.options[j].check = false;
			//   }
			// }
			// i.check = !i.check;
		},
		resetModal() {
			this.questions.isFailed = false;
		},
		addOptions() {
			if (this.questions.options.length >= 8) {
				this.moreOption = true;
			} else {
				this.moreOption = false;
			}
			if (!this.moreOption) {
				this.questions.options.push({
					value: "",
					media: "",
					check: false,
				});
			}
		},

		cancelForm() {
			this.$store.dispatch("questionVUEX/getQuestions", this.selectedSection);
		},
		removeMedia() {
			this.checkMedia = false;
			this.questions.questionMedia = "";
			this.questions.questionMediaType = null;
			this.questions.questionFile = null;
			this.questions.fileMeta = null;
			this.questions.isFailed = false;
			this.$forceUpdate();
		},
		deleteOptions(i) {
			this.questions.options.splice(i, 1);
			this.moreOption = false;
			this.$forceUpdate();
		},
		closeattachdocsmodal() {
			this.$bvModal.hide("attachdocs");
		},
		// clearing card data function
		clearData() {
			this.addques = true;
			this.$refs.questionTagref.reset();
			this.optionPreviews = [];
			this.erroroption = false;
			this.dirtyMcqQuestion = false;
			this.$emit("clearData");
			let rad = document.getElementsByName("some-radios");
			for (const radio of rad) {
				radio.checked = false;
			}
			this.singletick = true;
			this.showdatacard = false;
			this.$v.$reset();
			this.removeMedia();
			this.moreOption = false;
		},
	},
};
</script>

<style>
input[type="file"] {
	display: none;
}
.mcq-form-option .form-control {
	display: block;
	width: 100%;
	height: calc(1.5em + 0.75rem + 2px);
	padding-left: 0.5rem;
	padding-right: 2.75rem;
	padding-top: 0.375rem;
	padding-bottom: 0.375rem;
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
	background: #f2f4fd;
	border: none;
	border-bottom: 1px solid rgba(114, 115, 142, 0.35);
}
.b-form-tags {
	box-shadow: unset !important;
}
.mcq-radio-option-image {
	right: 10px;
	position: absolute;
	bottom: 5px;
}

.uploaded-option-image {
	width: 100px;
	height: 100px;
	border: 1px solid rgba(140, 140, 140, 0.3);
	border-radius: 4px;
	position: absolute;
	left: 0px;
	top: 43px;
}

.mcq-image-option-hovered-icons {
	position: absolute;
	top: 35px;
	left: 16px;
}
.disabled-opt {
	opacity: 0.5;
	cursor: not-allowed;
	pointer-events: auto;
}
.option-dup-text {
	top: 15px;
	left: 0px;
}
.has-option-error,
.has-option-error:focus {
	border-bottom: 1px solid red !important;
}
</style>
